import { useContext } from "react";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import moment from "moment-timezone";
import {AnswersStatisticsSearchContext} from "../AnswersStatisticsSearchContext";
import {InputText} from "primereact/inputtext";
import {FilterWrapperComponent} from "./parts/filter-wrapper";
import {TagMultiselect} from "../../../../../infecto-lms-admin/components/graph/editor/TagMultiselect";

export const AnswersStatisticsFiltersComponent = () => {
    const { filters, setFilters, clearFilters } = useContext(AnswersStatisticsSearchContext);

    return (
        <div className="flex column mb-5">
            <div className="flex flex-column justify-content-center">
               <FilterWrapperComponent label={"Auswahl Zeitraum"}>
                <Calendar
                    className="mb-2 mr-2"
                    showTime
                    hourFormat="24"
                    dateFormat={"dd.mm.yy"}
                    placeholder={"Mindestdatum"}
                    value={
                        filters.greaterThanDate
                            ? moment(filters.greaterThanDate.replace("[UTC]", "")).toDate()
                            : undefined
                    }
                    onChange={(e) => {
                        setFilters({
                            ...filters,
                            greaterThanDate: e.value
                                ? moment(e.value as Date).format("YYYY-MM-DDTHH:mmZ")
                                : undefined,
                        });
                    }}
                />

                <Calendar
                    className="mb-2 mr-2"
                    showTime
                    hourFormat="24"
                    dateFormat={"dd.mm.yy"}
                    placeholder={"Maximaldatum"}
                    value={
                        filters.lessThanDate
                            ? moment(filters.lessThanDate.replace("[UTC]", "")).toDate()
                            : undefined
                    }
                    onChange={(e) => {
                        setFilters({
                            ...filters,
                            lessThanDate: e.value
                                ? moment(e.value as Date).format("YYYY-MM-DDTHH:mmZ")
                                : undefined,
                        });
                    }}
                /></FilterWrapperComponent>
                <FilterWrapperComponent label={"Nach Titel filtern"}>
                <InputText
                    className="mb-2 w-25rem"
                    value={filters.filterByTitle || ""}
                    placeholder={"Nach Titel filtern"}
                    onChange={(e) => {
                        setFilters({ ...filters, filterByTitle: e.target.value });
                    }}
                /></FilterWrapperComponent>
                <FilterWrapperComponent label={"Nach Medienart filtern"}>
                 <TagMultiselect classname={"ml-0 mb-2 w-25rem"} selectedTags={filters.filterByTagIds}
                                        onSelect={(tagIds) => {
                                            setFilters({
                                                ...filters,
                                                filterByTagIds: tagIds?.length === 0 ? null : tagIds,
                                            });
                                        }}/>
                </FilterWrapperComponent>
            </div>

            <div className="flex align-items-center">
                <Button
                    className="ml-5"
                    label={"Zurücksetzen"}
                    icon="pi pi-times"
                    onClick={() => {
                        clearFilters();
                    }}
                />
            </div>
        </div>
    );
};
